module.exports = __webpack_public_path__ + "img/e324187.jpg";